import { menu } from "../interface/menu-interface";
import { userPermission } from "../interface/user";
import { UrlServices } from "./url-services";

export const MENU_ITEMS: menu[] = [
    {
        title: 'Dashboard',
        icon: 'las la-shapes la-lw',
        link: UrlServices.DASHBOARD_ROUTE,
        data: { permission: {} as userPermission },
    },
    {
        title: 'Patients',
        icon: 'las la-user-injured la-lw',
        link: UrlServices.PAGE_URL.PATIENT.LIST.URL,
        data: { permission: {} as userPermission },
    },
    {
        title: 'Appointments',
        icon: 'las la-notes-medical la-lw',
        link: UrlServices.PAGE_URL.APPOINTMENT.LIST.URL,
        data: { permission: {} as userPermission },
    },
    {
        title: 'Payments',
        icon: 'las la-money-bill',
        link: UrlServices.PAGE_URL.PAYMENTS.LIST.URL,
        data: { permission: {} as userPermission },
    },
    {
        title: 'Invoice',
        icon: 'las la-file-invoice',
        link: UrlServices.PAGE_URL.INVOICE.LIST.URL,
        data: { permission: {} as userPermission },
    },
    {
        title: 'Expense',
        icon: 'las la-money-check-alt',
        link: UrlServices.PAGE_URL.EXPENSE.LIST.URL,
        data: { permission: {} as userPermission },
    },
    {
        title: 'User',
        icon: 'las la-user la-lw',
        link: UrlServices.PAGE_URL.USER.LIST.URL,
        data: { permission: {} as userPermission },
    },
    {
        title: 'Settings',
        icon: 'las la-cogs la-lw',
        link: UrlServices.PAGE_URL.MASTER.GENERAL.URL,
        data: { permission: {} as userPermission },
  },
    {
      title: 'Reports',
      icon: 'las la-flag',
      link: UrlServices.PAGE_URL.REPORT.LIST.URL,
      data: { permission: {} as userPermission },
  },


];
